import type { ToolCallMessagePart } from '@assistant-ui/react';
import { motion } from 'motion/react';
import { use } from 'react';
import { useTranslation } from 'react-i18next';

import { ProjectContext } from '#core/contexts/ProjectContext.ts';

import classes from './ProgressBubble.module.css';
import { AtlasAiSpinner } from '#plugin-chat/components/hero/AtlasAiSpinner.tsx';
import { Shimmer } from '#plugin-chat/components/shared/Shimmer.tsx';
import { useToolLabel } from '#plugin-chat/hooks/useToolLabel.ts';
import { useToolsMap } from '#plugin-chat/hooks/useToolsMap.ts';

interface ProgressBubbleProps {
  // biome-ignore lint/suspicious/noExplicitAny: Runtime part — per-tool types are erased at this layer.
  toolPart?: ToolCallMessagePart<any, any>;
}

export function ProgressBubble({ toolPart }: ProgressBubbleProps) {
  const { t } = useTranslation('chat');
  const toolLabel = useToolLabel();
  const labelValues = useToolsMap()?.[toolPart?.toolName ?? '']?.labelValues;
  const { config } = use(ProjectContext);

  const args = (toolPart?.args ?? {}) as Record<string, unknown>;
  const progress = toolLabel(toolPart?.toolName, 'progress', labelValues?.({ args, result: undefined }));

  return (
    <motion.div
      animate={{
        // height: 'var(--progress-height)',
        opacity: 1,
        transform: 'translateX(0)',
      }}
      className={classes.bubble}
      exit={{
        // height: 0,
        opacity: 0,
        transform: 'translateX(-1rem)',
      }}
      initial={{
        // height: 0,
        opacity: 0,
        transform: 'translateX(-1rem)',
      }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <motion.div className={classes.spinner}>
        <AtlasAiSpinner />
      </motion.div>

      <Shimmer className={classes.label} color="white">
        {t('agentProgress', { agent: config.feature.ai.agent.name, progress })}
      </Shimmer>
    </motion.div>
  );
}
